import React, { useState, useEffect, useRef, useContext } from "react";

import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

import { getObtenerTypes } from "../../../API/Global/Types/TypeRequest"; 

import Card from "../../../Components/Card/Card";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";

import TypesCrudModal from "./TypesCrud/TypesCrudModal";


export const TypesScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [tipo, setTipo] = useState("");
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  const getInfo = async () => {
    setLoading(true);
    const c = await getObtenerTypes();
    setTipo(c);
    setLoading(false);
  };

  const colums = [
    {
      field: "IdType",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Type",
      header: "Tipo",
      headerEn: "Type",
      className:"XXlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "TypeCategory",
      header: "Categoría",
      headerEn: "Category",
      flex: 1
    },
    {
      field: "AbbreviatedType",
      header: "Abreviación",
      headerEn: "Abbreviation",
      className:"small"
    },
    {
      field: "Descripcion",
      header: "Descripción",
      headerEn: "Descripción",
      flex: 1   
    },
    {
      field: "IdType",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: tipo,
    loading: loading,
  };


  useEffect(() => {
    setTitlePage(getLabel(baseLang, "tipo", config.language));
    getInfo();
  }, [])

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast}></Toast>
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "tipo", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button icon='pi pi-plus' severity='success' onClick={() => {
                        setShowDialog(true);
                        setSelected(null);
                    }} />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && <TypesCrudModal toastRef={toast} tiposDialog={showDialog} tipo={selected} setTiposDialog={setShowDialog} getTypes={getInfo} modo={selected ? "Editar" : "Crear"}/>}
    </div>
  );
};

export default TypesScreen;
